import { store } from "../store/index";
import {
  synchronizeData,
  getAll,
  createViewer,
} from "../store/actions/ViewerActions";

/**
 * Update Farm
 */
export const synchDataViewers = async () => {
  const objSend = {};
  const result = await store.dispatch(synchronizeData("", objSend));
  if (result?.payload?.data) {
    return "OK";
  }
  return null;
};

/**
 * List Course
 */
export const listPersons = async (filter) => {
  const result = await store.dispatch(getAll(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const addViewer = async (values, sessionUuid) => {
  const result = await store.dispatch(createViewer(values, [sessionUuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};
